import * as Sentry from '@sentry/react';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { createWebNotification } from '../../graphql/custom/web-notification';

export const withCreateWebNotification = (Component) => {
	return compose(
		graphql(gql(createWebNotification), {
			options: {
				context: {
					headers: {
						'x-frame-options': 'deny', // This header will reach the server
					},
				},
				fetchPolicy: 'no-cache',
			},
			props: (props) => ({
				onCreateWebNotification(payload) {
					const { job, ...variables } = payload;
					return props
						.mutate({
							context: {
								headers: {
									'x-frame-options': 'deny', // This header will reach the server
								},
							},
							variables,
						})
						.then((resp) => {
							const result = resp.data.createWebNotification;
							const isJobClosed = Boolean(
								job && job.status && job.status !== 'open'
							);
							if (isJobClosed) {
								Sentry.captureMessage(
									'Web notification created for closed job',
									{
										level: 'warning',
										tags: { web_notification_closed_job: true },
										extra: {
											jobId: job.id,
											jobStatus: job.status,
											notificationType: variables?.input?.type,
											notificationId: result?.id,
										},
									}
								);
							}
							return result;
						});
				},
			}),
		})
	)(Component);
};
